<!--
 * @Author: weiyong
 * @Description: logo component
-->
<template>
  <div class="anticon" :class="getAppLogoClass" @click="goHome">
    <img
      v-if="showLogo&&!loadingLogoFlag"
      :key="logoUrlObj"
      :src="logoUrlObj"
      :class="`${prefixCls}__logo-img`"
      :style="imgSty"
    />
    <div v-if="!isFrameType" class="ml-2 truncate md:opacity-100" :style="'font-size:'+fontSizeTitle+'px'" :class="getTitleClass" v-show="!getCollapsed&&getShowSystemTitle">
      {{ systemName  }}
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed, unref } from 'vue';
  import { useGlobSetting } from '@/hooks/setting';
  import { useGo } from '@/hooks/web/usePage';
  import { useMenuSetting } from '@/hooks/setting/useMenuSetting';
  import { useDesign } from '@/hooks/web/useDesign';
  import { PageEnum } from '@/enums/pageEnum';
  import { useUserStore } from '@/store/modules/user';
  import { useAccountInfo } from '@/components/Application/hooks/useAccountInfo';
  import {CurrentUtils} from "xmgoing-server";
  import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";
  import { useAppFrame } from '@/hooks/useAppFrame';
  const { systemName, logoUrlObj,loadingLogoFlag,logoHeightVal,logoWidthVal,fontSizeTitle } = useAccountInfo();

  const props = defineProps({
    /**
     * The theme of the current parent component
     */
    theme: { type: String, validator: (v: string) => ['light', 'dark'].includes(v) },
    /**
     * Whether to show title
     */
    showTitle: { type: Boolean, default: true },
    showLogo: { type: Boolean, default: true },
    /**
     * The title is also displayed when the menu is collapsed
     */
    alwaysShowTitle: { type: Boolean },
  });

  const { prefixCls } = useDesign('app-logo');
  const { getCollapsedShowTitle } = useMenuSetting();
  const userStore = useUserStore();
  const { title } = useGlobSetting({systemName});

  const {
    getShowSystemTitle,
  } = useHeaderSetting();
  const {
    getCollapsed
  } = useMenuSetting();
  const { isFrameType } = useAppFrame();
  const imgSty = computed(() => ({
    maxWidth: `${unref(logoWidthVal)}px`,
    maxHeight: `${unref(logoHeightVal)}px`,
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
  }));
  const go = useGo();

  const getAppLogoClass = computed(() => [
    prefixCls,
    props.theme,
    { 'collapsed-show-title': unref(getCollapsedShowTitle) },
  ]);

  const getTitleClass = computed(() => [
    `${prefixCls}__title`,
    {
      'xs:opacity-0': !props.alwaysShowTitle,
    },
  ]);

  function goHome() {
    CurrentUtils.loadCurrentAccount(false,(res)=>{
      //如果租户自己定义了网址 则点击logo跳转自己的网址
      if(res&&res.netAddress){
        if(res.netAddress.startsWith("/")){
          window.appObj.$router.push({path:res.netAddress});
        }
        if(res.netAddress.startsWith("http")){
           window.open(res.netAddress);
        }
      }else{
        go(userStore.getUserInfo.homePath || PageEnum.BASE_HOME);
      }
    })

  }
</script>
<style lang="less" scoped>
  @prefix-cls: ~'@{namespace}-app-logo';

  .@{prefix-cls} {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    padding-left: 7px;
    cursor: pointer;
    transition: all 0.2s ease;

    &.light {
      border-bottom: 1px solid @border-color-base;
    }

    &.collapsed-show-title {
      padding-left: 20px;
    }

    &.light &__title {
      color: @primary-color;
    }

    &.dark &__title {
      color: @white;
    }

    &__title {
      font-size: 16px;
      font-weight: 700;
      transition: all 0.5s;
      line-height: normal;
    }

    &__logo-img {
      width: auto !important;
      height: auto !important;
      object-fit: contain;
      flex-shrink: 0;
    }
  }
</style>
